import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const CrewColored = ({ size = 'xsmall' }: IconProps) => {
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            className="icon-freeform"
        >
            <g id="Crew" fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="m8.807 17.788-3.438-3.376c-.22-.222-.22-.805 0-1.027l7.117-7.728c.656-.665 1.785-.303 2.662 0l1.957.918 1.301 2.711c.3.89-.28 1.585-.935 2.25l-4.985 5.204-3.68 1.048z"
                    fill="#E69845"
                />
                <path
                    d="m9.2 16.74-2.86-2.898 6.815-6.907a1.182 1.182 0 0 1 1.238-.294l2.246.776.767 2.282a1.27 1.27 0 0 1-.294 1.288l-4.927 4.994c-.063 0-.12-.007-.185-.007-1.368 0-2.171.397-2.8.766m12.8-.766c-1.527 0-2.352.495-3.015.893-.587.353-1.012.608-1.985.608-.973 0-1.397-.255-1.985-.608a10.967 10.967 0 0 0-.573-.325l4.094-4.15a3.245 3.245 0 0 0 .766-3.329l-.728-2.166 4.139-4.195a1 1 0 0 0-1.424-1.404L17.16 5.481l-2.116-.73a3.212 3.212 0 0 0-3.314.78l-7.146 7.243c-.58.588-.58 1.547 0 2.136l2.524 2.558c-.04.001-.068.007-.11.007-.972 0-1.396-.255-1.984-.608-.663-.398-1.488-.893-3.014-.893a1 1 0 1 0 0 2c.972 0 1.397.255 1.984.608.663.398 1.488.893 3.015.893 1.527 0 2.352-.495 3.015-.893.588-.353 1.012-.608 1.985-.608.973 0 1.398.255 1.985.608.663.398 1.488.893 3.015.893 1.527 0 2.352-.495 3.015-.893.588-.353 1.012-.608 1.985-.608a1 1 0 0 0 0-2m0 3.524c-1.527 0-2.352.496-3.015.894-.588.353-1.012.608-1.985.608-.973 0-1.397-.255-1.985-.608-.663-.398-1.488-.894-3.015-.894-1.527 0-2.352.496-3.015.894C8.397 20.745 7.973 21 7 21c-.973 0-1.397-.255-1.985-.608-.663-.398-1.488-.894-3.015-.894a1 1 0 0 0 0 2c.973 0 1.397.255 1.985.608C4.648 22.504 5.473 23 7 23c1.527 0 2.352-.496 3.015-.894.588-.353 1.012-.608 1.985-.608.973 0 1.397.255 1.985.608.663.398 1.488.894 3.015.894 1.527 0 2.352-.496 3.015-.894.588-.353 1.012-.608 1.985-.608a1 1 0 0 0 0-2"
                    fill="#0F1011"
                />
            </g>
        </svg>
    );
};
